const Share = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M14.5 5.25a2 2 0 1 1 4 0 2 2 0 0 1-4 0zm2 4a3.986 3.986 0 0 1-2.717-1.065l-3.984 2.56a3.997 3.997 0 0 1 0 2.509l3.985 2.56a4 4 0 1 1-1.083 1.681l-3.984-2.56a4 4 0 1 1 0-5.872l3.983-2.56a4 4 0 1 1 3.8 2.747zm-8.787 3.783a1.03 1.03 0 0 0-.062.096 2 2 0 1 1 .062-.096zm7.082 4.67a2 2 0 1 0 3.41 2.093 2 2 0 0 0-3.41-2.093z" fill="#000" />
    </svg>
)

export default Share;